import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/information',
  component: LAYOUT,
  name: 'Information',
  redirect: '/information/detail',
  meta: {
    title: '资讯详情',
  },
  children: [
    {
      path: 'detail',
      name: 'InformationDetail',
      meta: {
        title: '资讯详情',
      },
      component: () => import('@/views/information/detail'),
    },
  ],
};
